export const GetMoneyText = (data: number | null | undefined) => {
  return `¥${(data ?? 0).toLocaleString()}`;
};
